import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import CommonService from "../../services/common.service";
import Loader from "../Common/Loader";
import useAutoAddQueryString from "../../Helpers/useAutoAddQueryString";
const GameChart = () => {
  useAutoAddQueryString();
  const [data, setData] = useState([]);
  const [teamCount, setTeamCount] = useState([]);
  const [teamCountTotal, setTeamCountTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isGameBarLoading, setIsGameBarLoading] = useState(true);
  const [labelNames, setLabelNames] = useState([]);
  const [gameView, setGameView] = useState([]);
  const [tradeCount, setTradeCount] = useState([]);
  const [gameInfoData, setGameInfoData] = useState({});

  // GameBar variable here
  const [goData, setGoData] = useState([]);
  const [gksData, setGksData] = useState([]);
  const [ogData, setOgData] = useState([]);
  const [assistsData, setAssistsData] = useState([]);
  const [piData, setPiData] = useState([]);
  const [twData, setTwData] = useState([]);
  const [psData, setPsData] = useState([]);
  const [pmData, setPmData] = useState([]);
  const [gcdData, setGcdData] = useState([]);
  const [ycdData, setYcdData] = useState([]);
  const [rcdData, setRcdData] = useState([]);
  const [cstData, setCstData] = useState([]);
  const [p60Data, setP60Data] = useState([]);
  const [p60PlusData, setP60PlusData] = useState([]);
  const [fpsData, setFpsData] = useState([]);
  const [fantasyPointsData, setFantasyPointsData] = useState({});
  useEffect(() => {
    CommonService.gameChart()
      .then((res) => {
        if (res.success) {
          setData(res.data);
          setTeamCount(res.teamCounts);
          setTeamCountTotal(res.totalCount);
          setLabelNames(res.labels);
          setGameView(res.roundGameViewCounts);
          setTradeCount(res.tradeCountData);
          setGameInfoData(res.gameInfoBlockData);
          setIsLoading(false);
        }
      })
      .then(() => {
        CommonService.getGameBarGraph().then((res) => {
          if (res.success) {
            setGoData(res.goData);
            setGksData(res.gksData);
            setOgData(res.ogData);
            setAssistsData(res.assistsData);
            setPiData(res.piData);
            setTwData(res.twData);
            setPsData(res.psData);
            setPmData(res.pmData);
            setGcdData(res.gcdData);
            setYcdData(res.ycdData);
            setRcdData(res.rcdData);
            setCstData(res.cstData);
            setP60Data(res.p60Data);
            setP60PlusData(res.p60PlusData);
            setFpsData(res.fpRangeData);
            setIsGameBarLoading(false);
          }
        });
      })
      .then(() => {
        CommonService.getFantasyScoreTotal().then((res) => {
          if (res.success) {
            setFantasyPointsData(res.data);
          }
        });
      });
  }, []);

  // Game Bar chart logic start here

  const dataGoalsValues = goData
    ? Object.values(goData).map((value) => parseInt(value, 10))
    : [];

  const dataGkSavesValues = gksData
    ? Object.values(gksData).map((value) => parseInt(value, 10))
    : [];

  const dataOwnGoalsValues = ogData
    ? Object.values(ogData).map((value) => parseInt(value, 10))
    : [];

  const dataAssistsValues = assistsData
    ? Object.values(assistsData).map((value) => parseInt(value, 10))
    : [];

  const dataPiValues = piData
    ? Object.values(piData).map((value) => parseInt(value, 10))
    : [];

  const dataTwValues = twData
    ? Object.values(twData).map((value) => parseInt(value, 10))
    : [];

  const dataPsValues = psData
    ? Object.values(psData).map((value) => parseInt(value, 10))
    : [];

  const dataPmValues = pmData
    ? Object.values(pmData).map((value) => parseInt(value, 10))
    : [];
  const dataGcdValues = gcdData
    ? Object.values(gcdData).map((value) => parseInt(value, 10))
    : [];
  const dataYcdValues = ycdData
    ? Object.values(ycdData).map((value) => parseInt(value, 10))
    : [];
  const dataRcdValues = rcdData
    ? Object.values(rcdData).map((value) => parseInt(value, 10))
    : [];
  const dataCstValues = cstData
    ? Object.values(cstData).map((value) => parseInt(value, 10))
    : [];
  const dataP60Values = p60Data
    ? Object.values(p60Data).map((value) => parseInt(value, 10))
    : [];
  const dataP60PlusValues = p60PlusData
    ? Object.values(p60PlusData).map((value) => parseInt(value, 10))
    : [];

  const dataFpValues = fpsData
    ? Object.values(fpsData).map((value) => parseInt(value, 10))
    : [];

  const formatteGoalsdData = {
    series: [
      {
        name: "Goal Per Match",
        data: dataGoalsValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Goal Per Match",
        align: "left",
      },
    },
  };

  const formattedGksavesData = {
    series: [
      {
        name: "GK Saves Per Match",
        data: dataGkSavesValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "GK Saves Per Match",
        align: "left",
      },
    },
  };

  const formattedOgData = {
    series: [
      {
        name: "Own Goal Per Match",
        data: dataOwnGoalsValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Own Goal Per Match",
        align: "left",
      },
    },
  };
  const formattedASTData = {
    series: [
      {
        name: "Assist Per Match",
        data: dataAssistsValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8-9", "21+"],
      },
      title: {
        text: "Assist Per Match",
        align: "left",
      },
    },
  };
  const formattedPIData = {
    series: [
      {
        name: "Passes Intercepted Per Match",
        data: dataPiValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "6", "6", "7", "8"],
      },
      title: {
        text: "Passes Intercepted Per Match",
        align: "left",
      },
    },
  };
  const formattedTwData = {
    series: [
      {
        name: "Tackles Wons Per Match",
        data: dataTwValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "6", "6", "7", "8"],
      },
      title: {
        text: "Tackles Wons Per Match",
        align: "left",
      },
    },
  };

  const formattedPsData = {
    series: [
      {
        name: "Penalty Saves Per Match",
        data: dataPsValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "6", "6", "7", "8"],
      },
      title: {
        text: "Penalty Saves Per Match",
        align: "left",
      },
    },
  };
  const formattedPmData = {
    series: [
      {
        name: "Penalty Miss Per Match",
        data: dataPmValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "6", "6", "7", "8"],
      },
      title: {
        text: "Penalty Miss Per Match",
        align: "left",
      },
    },
  };
  const formattedGcdData = {
    series: [
      {
        name: "Green Card Per Match",
        data: dataGcdValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "6", "6", "7", "8"],
      },
      title: {
        text: "Green Card Per Match",
        align: "left",
      },
    },
  };
  const formattedYcdData = {
    series: [
      {
        name: "Yellow Card Per Match",
        data: dataYcdValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "6", "6", "7", "8"],
      },
      title: {
        text: "Yellow Card Per Match",
        align: "left",
      },
    },
  };
  const formattedRcdData = {
    series: [
      {
        name: "Red Card Per Match",
        data: dataRcdValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "6", "6", "7", "8"],
      },
      title: {
        text: "Red Card Per Match",
        align: "left",
      },
    },
  };
  const formattedCstData = {
    series: [
      {
        name: "Clean Sheet Per Match",
        data: dataCstValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "6", "6", "7", "8"],
      },
      title: {
        text: "Clean Sheet Per Match",
        align: "left",
      },
    },
  };
  const formattedP60Data = {
    series: [
      {
        name: "Played 60mins Per Match",
        data: dataP60Values,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "6", "6", "7", "8"],
      },
      title: {
        text: "Played 60mins Per Match",
        align: "left",
      },
    },
  };

  const formattedP60PlusData = {
    series: [
      {
        name: "Played 60+mins Per Match",
        data: dataP60PlusValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "6", "6", "7", "8"],
      },
      title: {
        text: "Played 60+mins Per Match",
        align: "left",
      },
    },
  };

  const formattedFpData = {
    series: [
      {
        name: "Fantasy Points Per Match",
        data: dataFpValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: [
          "1-5",
          "6-10",
          "11-15",
          "16-20",
          "21-30",
          "31-40",
          "41-50",
          "51+",
        ],
      },
      title: {
        text: "Fantasy Points Per Match",
        align: "left",
      },
    },
  };
  // Game Bar chart logic start here

  function getRandomColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
  const chartData = {
    series: [data?.gkCount, data?.defCount, data?.midCount, data?.fwdCount],
  };

  const chartOptions = {
    labels: ["GK", "DEF", "MID", "FWD"],
    colors: ["#4BC0C0", "#36A2EB", "#FFCE56"],
    title: {
      text: "Player Types",
      align: "left",
    },
  };

  //   Fixture per team graph start here

  const teamData = teamCount.map((team) => {
    const percentage = ((team.team_count / teamCountTotal) * 100).toFixed(2);
    return {
      name: team.team_name,
      data: team.team_count,
      percentage: percentage,
      color: getRandomColor(), // Assuming you have a function to generate random colors
    };
  });

  const chartData1 = {
    series: teamData.map((team) => team.data),
  };

  const chartOptions1 = {
    labels: teamData.map((team) => `${team.name} (${team.percentage}%)`),
    colors: teamData.map((team) => team.color),
    title: {
      text: "Fixtures Per Team",
      align: "left",
    },
  };
  //   Fixture per team graph finish here

  //   Player Used graph start here
  const chartData2 = {
    series: [data?.playerInUse, data?.playerNotInUse],
  };

  const chartOptions2 = {
    labels: [`Yes (${data?.inUsePercent}%)`, `No (${data?.notInUsePercent}%)`],
    colors: ["#4BC0C0", "#36A2EB"],
    title: {
      text: "Player Used",
      align: "left",
    },
  };
  //   Player Used graph finish here

  //   Team Picked graph start here
  const chartData3 = {
    series: [data?.membersWithTeamCount, data?.membersWithoutTeamCount],
  };

  const chartOptions3 = {
    labels: [
      `Picked Team (${data?.membersWithTeamPercent}%)`,
      `Not Picked Team (${data?.membersWithoutPercent}%)`,
    ],
    colors: ["#4BC0C0", "#36A2EB"],
    title: {
      text: "Team Selection",
      align: "left",
    },
  };
  //   Team Picked graph finish here

  // Gameviews and trades count

  const labelNamesOptions = Object.keys(labelNames);
  const gameViewData = Object.values(gameView).map((value) =>
    parseFloat(value, 10)
  );
  const tradeCountData = Object.values(tradeCount).map((value) =>
    parseFloat(value, 10)
  );

  const formattedGameViewData = {
    series: [
      {
        name: "Gameviews",
        data: gameViewData,
      },
    ],
  };

  const gameViewOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesOptions,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Gameviews",
      align: "left",
    },
  };

  const formattedTradeCountData = {
    series: [
      {
        name: "Trades",
        data: tradeCountData,
      },
    ],
  };

  const tradeCountOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesOptions,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Trades",
      align: "left",
    },
  };
  // Gameviews and trades count

  const clubDetails = JSON.parse(localStorage.getItem("club_details"));

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <div className="middle-section">
        <div className="container-fluid">
          <div className="innerwhite-section">
            <div className="heading">
              <h2>Game Charts</h2>
            </div>
            <div className="countdata mt-4 mb-4">
              <div className="gameweek-filter">
                <h4>{clubDetails?.game_name}</h4>
              </div>
              <div className="container">
                <ul>
                  <li>
                    <div className="countbox">
                      <strong>{gameInfoData?.teamEntered}</strong>
                      <span>Teams Entered</span>
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>{gameInfoData?.totalPlayer}</strong>
                      <span>Players Added</span>
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>{gameInfoData?.trade_used}</strong>
                      <span>Trades Used</span>
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>{gameInfoData?.player_profile_views}</strong>
                      <span>Player Views</span>
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>{gameInfoData?.gameViews}</strong>
                      <span>Gameviews</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="countdata mt-4 mb-4">
              <div className="gameweek-filter">
                <h4>Total Numbers</h4>
              </div>

              <div className="container">
                <ul>
                  <li>
                    <div className="countbox">
                      <strong>{fantasyPointsData?.sum_go}</strong>
                      <span> Goals</span>
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>{fantasyPointsData?.sum_ast}</strong>
                      <span> Assists</span>
                    </div>
                  </li>

                  <li>
                    <div className="countbox">
                      <strong>{fantasyPointsData?.sum_ps}</strong>
                      <span>Penalty Saves</span>
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>{fantasyPointsData?.sum_pm}</strong>
                      <span> Penalty Miss</span>
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>{fantasyPointsData?.sum_gks}</strong>
                      <span> GK Saves</span>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="container">
                <ul>
                  <li>
                    <div className="countbox">
                      <strong>{fantasyPointsData?.sum_gcd}</strong>
                      <span> Green Cards</span>
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>{fantasyPointsData?.sum_ycd}</strong>
                      <span>Yellow Cards</span>
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>{fantasyPointsData?.sum_rcd}</strong>
                      <span> Red Cards</span>
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>{fantasyPointsData?.sum_cst}</strong>
                      <span> Clean Sheets</span>
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>{fantasyPointsData?.sum_p60}</strong>
                      <span> Played 60mins</span>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="container">
                <ul>
                  <li>
                    <div className="countbox">
                      <strong>{fantasyPointsData?.sum_p60plus}</strong>
                      <span> Played 60+mins</span>
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>{fantasyPointsData?.sum_fp?.toFixed(2)}</strong>
                      <span>Fantasy Points</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div className="row pb-3">
              <div className="col-md-6 col-sm-12">
                <div className="tab-content">
                  <Chart
                    options={gameViewOptions}
                    series={formattedGameViewData.series}
                    type="line"
                    height={350}
                  />
                </div>
              </div>
              <div className="col-md-6 col-sm-12">
                <div className="tab-content">
                  <Chart
                    options={tradeCountOptions}
                    series={formattedTradeCountData.series}
                    type="line"
                    height={350}
                  />
                </div>
              </div>
            </div>

            <ul className="sponsor_list bonus-card  chart-strech">
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={chartOptions}
                    series={chartData.series}
                    type="pie"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={chartOptions1}
                    series={chartData1.series}
                    type="donut"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={chartOptions2}
                    series={chartData2.series}
                    type="donut"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={chartOptions3}
                    series={chartData3.series}
                    type="donut"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formatteGoalsdData.chartOptions}
                    series={formatteGoalsdData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedGksavesData.chartOptions}
                    series={formattedGksavesData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedOgData.chartOptions}
                    series={formattedOgData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedASTData.chartOptions}
                    series={formattedASTData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>

              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedPsData.chartOptions}
                    series={formattedPsData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedPmData.chartOptions}
                    series={formattedPmData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedGcdData.chartOptions}
                    series={formattedGcdData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedYcdData.chartOptions}
                    series={formattedYcdData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedRcdData.chartOptions}
                    series={formattedRcdData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedCstData.chartOptions}
                    series={formattedCstData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedP60Data.chartOptions}
                    series={formattedP60Data.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedP60PlusData.chartOptions}
                    series={formattedP60PlusData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedFpData.chartOptions}
                    series={formattedFpData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default GameChart;
